import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import WingLeft from "../../shared/images/wing-left.png";
import WingRight from "../../shared/images/wing-right.png";
import LazyImage from "../../shared/lazy-image";
import { Text } from "@cars24/turbo-web/lib/text";

const EChallanTrustFactors = ({ trustChallanData }) => {
    const { tokens } = useTokens();
    const { title = "", trustData = [] } = trustChallanData || {};

    const trustFactorList = trustData.map((item) => ({
        journeyTitle: item.title,
        text: item.description
    }));

    if (!trustFactorList.length) {
        return null;
    }

    return (
        <div styleName={"styles.ratingSectionWrapper"}>
            <div styleName={"styles.overlay"} />
            <div styleName={"styles.titleWrapper"}>
                <div styleName={"styles.divider"} />
                <Text size="350" color={tokens.text_default_text_inverse} as="h2" fontWeight="semibold">
                    {title}
                </Text>
                <div styleName={"styles.divider"} />
            </div>

            <div styleName={"styles.ratingText"}>
                {trustFactorList.map((el, i) => (
                    <div styleName={"styles.text"} key={i}>
                        <LazyImage src={WingLeft} alt="left wing" styleName={"styles.wing"} />
                        <div styleName={"styles.content"}>
                            <Text size="450" fontWeight="semibold" color={tokens.text_default_text_inverse}>{el?.journeyTitle}</Text>
                            <Text size="250" fontWeight="regular" color={tokens.text_default_text_tertiary}>{(el?.text || "")}</Text>
                        </div>
                        <LazyImage src={WingRight} alt="right wing" styleName={"styles.wing"} />
                    </div>
                ))}
            </div>
        </div>
    );
};

EChallanTrustFactors.propTypes = {
    trustChallanData: PropTypes.object
};

export default EChallanTrustFactors;
